import React, { useState } from 'react';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import { ClickAwayListener, IconButton, Tooltip } from '@mui/material';
import Box from '../primitives/Box';

export interface HelpTipProps {
  title: React.ReactNode;
  /** Accessible name for the help button */
  label?: string;
}

/**
 * Small "?" icon that shows a tooltip on click (not hover).
 * Closes on outside click or Escape.
 */
const HelpTip: React.FC<HelpTipProps> = ({ title, label = 'Help' }) => {
  const [open, setOpen] = useState(false);

  return (
    <ClickAwayListener onClickAway={() => setOpen(false)}>
      <Box component="span" sx={{ display: 'inline-flex', verticalAlign: 'middle' }}>
        <Tooltip
          title={title}
          open={open}
          onClose={() => setOpen(false)}
          disableHoverListener
          disableFocusListener
          disableTouchListener
          arrow
          placement="top"
          slotProps={{
            tooltip: {
              sx: {
                maxWidth: 280,
                fontSize: '0.75rem',
                lineHeight: 1.4,
              },
            },
          }}
        >
          <IconButton
            size="small"
            aria-label={label}
            aria-expanded={open}
            onClick={(event) => {
              event.preventDefault();
              event.stopPropagation();
              setOpen((prev) => !prev);
            }}
            onMouseDown={(event) => {
              // Prevent FormControlLabel / label from stealing the click.
              event.preventDefault();
              event.stopPropagation();
            }}
            sx={{
              p: 0.25,
              ml: 0.25,
              color: 'text.secondary',
              verticalAlign: 'middle',
            }}
          >
            <HelpOutlineIcon sx={{ fontSize: 16 }} />
          </IconButton>
        </Tooltip>
      </Box>
    </ClickAwayListener>
  );
};

export default HelpTip;
